import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="terms-of-service-page" style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '4rem 0 2rem',
        marginBottom: '3rem'
      }}>
        <div className="container">
          <div className="text-center text-white">
            <h1 className="display-4 fw-bold mb-3">
              <i className="fas fa-file-contract me-3"></i>
              Terms & Conditions
            </h1>
            <p className="lead mb-2">
              Please read these terms carefully before using our platform.
            </p>
            <p className="mb-0 opacity-75">
              <small>Status: Draft | BRAINTONICA EDTECH LLP — WiZiAi</small>
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mb-5">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-5">
            
            {/* Introduction */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-handshake me-2"></i>
                1.1 Introduction
              </h2>
              <p className="text-muted">
                Welcome to <strong>WiZiAi</strong>, an AI-powered test-prep platform (the "Service") provided by <strong>BRAINTONICA EDTECH LLP</strong> ("WiZiAi", "we", "us" or "our"). These Terms and Conditions ("Terms") govern your access to and use of the WiZiAi website, WiZiAi Android application on Google Play and WiZiAi iOS application on the Apple App Store (collectively, the "Platform"). By creating an account, downloading the app, or using any part of the Platform, you agree to be bound by these Terms.
              </p>
            </section>

            {/* Definitions */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-book me-2"></i>
                1.2 Definitions
              </h2>
              <ul className="list-unstyled">
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>User / You:</strong> Any natural person or entity using the Platform.</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Account:</strong> Your registered user account on the Platform.</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>Content:</strong> Any text, images, test responses, answers, feedback or other materials uploaded or generated by the user.</li>
                <li className="mb-2"><i className="fas fa-angle-right text-primary me-2"></i><strong>AI Features:</strong> Automated features such as score prediction, personalized study plans, automated grading, mentoring suggestions, counselling prompts, etc.</li>
                <li className="mb-0"><i className="fas fa-angle-right text-primary me-2"></i><strong>Services:</strong> All features and functionalities offered by WiZiAi via the Platform.</li>
              </ul>
            </section>

            {/* Acceptance */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-check-circle me-2"></i>
                1.3 Acceptance of Terms
              </h2>
              <p className="text-muted mb-0">
                By accessing or using the Services, you accept and agree to be bound by these Terms. If you accept on behalf of a company/organization, you represent that you have authority to bind that entity.
              </p>
            </section>

            {/* Eligibility */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-user-check me-2"></i>
                1.4 Eligibility and Age Restrictions
              </h2>
              <ol className="text-muted">
                <li className="mb-2">You must be at least 13 years old to register for a user account. If you are under the age required by applicable law in your jurisdiction to consent to online services without parental approval, you may only access the Platform with verified parental or guardian consent and supervision.</li>
                <li className="mb-2">If you are a parent or guardian, by creating an account for a minor you acknowledge and agree you provide consent for processing the minor's personal data and that you accept these Terms on the minor's behalf.</li>
                <li className="mb-0">WiZiAi may place additional restrictions in jurisdictions with stricter youth protection laws.</li>
              </ol>
            </section>

            {/* Account Registration */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-user-plus me-2"></i>
                1.5 Account Registration & Security
              </h2>
              <ol className="text-muted">
                <li className="mb-2">Users must provide accurate, current and complete information during registration and keep that information updated.</li>
                <li className="mb-2">You are responsible for maintaining the confidentiality of your account credentials. Notify WiZiAi immediately of any unauthorized use.</li>
                <li className="mb-0">WiZiAi reserves the right to suspend or terminate accounts suspected of fraud or misuse.</li>
              </ol>
            </section>

            {/* Services Provided */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-cogs me-2"></i>
                1.6 Services Provided
              </h2>
              <p className="text-muted mb-3">WiZiAi offers the following types of services:</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-clipboard-list text-primary me-2"></i>Diagnostic & Practice Tests</h5>
                      <p className="mb-0 small text-muted">For NEET and JEE preparation</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-robot text-primary me-2"></i>AI-Powered Grading</h5>
                      <p className="mb-0 small text-muted">Automated grading and feedback</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-route text-primary me-2"></i>Study Plans</h5>
                      <p className="mb-0 small text-muted">AI-generated personalized learning paths</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-chart-line text-primary me-2"></i>Performance Analytics</h5>
                      <p className="mb-0 small text-muted">Dashboards, reports, and trend analysis</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-user-graduate text-primary me-2"></i>Virtual Mentoring</h5>
                      <p className="mb-0 small text-muted">Counselling prompts and guidance</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card border-0 bg-light h-100">
                    <div className="card-body">
                      <h5 className="h6 fw-bold mb-2"><i className="fas fa-bullseye text-primary me-2"></i>Score Predictions</h5>
                      <p className="mb-0 small text-muted">Predictive models and trend analysis</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="alert alert-info mt-3 mb-0">
                <i className="fas fa-info-circle me-2"></i>
                WiZiAi may modify, suspend, or discontinue any aspect of the Services at any time.
              </div>
            </section>

            {/* Subscriptions & Payments */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-credit-card me-2"></i>
                1.7 Subscriptions, Payments and Refunds
              </h2>
              <ol className="text-muted">
                <li className="mb-2">Some Services are free and others are payable ("Paid Services"). If you subscribe to Paid Services, you agree to pay all fees in the plan you select.</li>
                <li className="mb-2">Payment processing is performed by third-party providers (payment gateways). Your payment information is handled in accordance with the payment provider's terms and is not stored by WiZiAi except as necessary and with appropriate security.</li>
                <li className="mb-0">Refunds and cancellations follow the refund policy available in the App and on the Platform. Where applicable consumer protection laws provide additional rights, those laws shall prevail.</li>
              </ol>
            </section>

            {/* User Content */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-file-upload me-2"></i>
                1.8 User Content, Data & License
              </h2>
              <ol className="text-muted">
                <li className="mb-2">You retain ownership of content you submit. By submitting content you grant WiZiAi a worldwide, royalty-free, sublicensable, transferable license to host, store, use, reproduce, modify, adapt, publish, and distribute such content for the purposes of providing, improving, and promoting the Services, including training anonymized models unless you opt out where opt-out is available.</li>
                <li className="mb-2">WiZiAi may aggregate and anonymize user content and analytics to improve services and create benchmark datasets. Anonymized datasets shall not be identifiable to individual users.</li>
                <li className="mb-0">Prohibited content (inflammatory, infringing, pornographic, illegal) may be removed at WiZiAi's discretion.</li>
              </ol>
            </section>

            {/* AI Features */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-brain me-2"></i>
                1.9 AI Features: Scope & Limitations
              </h2>
              <ol className="text-muted">
                <li className="mb-2">The Platform uses AI to provide insights, predictions, and recommendations. These outputs are probabilistic and for educational assistance only.</li>
                <li className="mb-2">AI outputs are not guarantees of future performance, admission results, or examination scores.</li>
                <li className="mb-2">Users should not rely solely on AI outputs for high-stakes decisions (e.g., admissions, career choices) without human verification.</li>
                <li className="mb-0">WiZiAi will provide an option to flag or contest AI outputs; contested items will be reviewed using the Platform's dispute procedures.</li>
              </ol>
            </section>

            {/* Intellectual Property */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-copyright me-2"></i>
                1.10 Intellectual Property Rights
              </h2>
              <ol className="text-muted">
                <li className="mb-2">All intellectual property rights in the Platform, Services, software, trademarks and content (excluding user-submitted content) belong to WiZiAi or its licensors.</li>
                <li className="mb-0">Users are granted a limited, non-exclusive, non-transferable license to use the Platform for personal, non-commercial educational purposes.</li>
              </ol>
            </section>

            {/* Prohibited Conduct */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-ban me-2"></i>
                1.11 Prohibited Conduct
              </h2>
              <p className="text-muted mb-2">You agree not to:</p>
              <ul className="text-muted">
                <li className="mb-2">Use the Platform for unlawful purposes</li>
                <li className="mb-2">Attempt to reverse engineer, hack, or interfere with the Platform</li>
                <li className="mb-2">Submit content that infringes the rights of others</li>
                <li className="mb-2">Harvest or collect user data without consent</li>
                <li className="mb-0">Use bots or automated systems to access the Services except as explicitly permitted</li>
              </ul>
            </section>

            {/* Third Party Services */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-link me-2"></i>
                1.12 Third-party Services & Links
              </h2>
              <p className="text-muted mb-0">
                The Platform may link to third-party services and integrate third-party tools (e.g., payment gateways, analytics, cloud providers). WiZiAi is not responsible for third-party policies or performance.
              </p>
            </section>

            {/* Termination */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-times-circle me-2"></i>
                1.13 Termination & Suspension
              </h2>
              <p className="text-muted mb-0">
                WiZiAi may suspend or terminate accounts for violations of these Terms or for operational reasons. On termination, WiZiAi may delete associated content in accordance with the Privacy Policy.
              </p>
            </section>

            {/* Disclaimers */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-exclamation-triangle me-2"></i>
                1.14 Disclaimers & Limitation of Liability
              </h2>
              <ol className="text-muted">
                <li className="mb-2">The Platform and Services are provided "as is" and "as available". WiZiAi disclaims all warranties to the fullest extent permitted by law.</li>
                <li className="mb-2">To the maximum extent permitted by applicable law, WiZiAi's aggregate liability for any claims arising out of or related to the Services is limited to the amount paid by you to WiZiAi in the 12 months preceding the claim (or a small minimum cap where required by law).</li>
                <li className="mb-0">WiZiAi is not liable for indirect, special, incidental, punitive, or consequential damages, lost profits, or lost data.</li>
              </ol>
            </section>

            {/* Indemnification */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-shield-alt me-2"></i>
                1.15 Indemnification
              </h2>
              <p className="text-muted mb-0">
                You agree to indemnify, defend and hold harmless WiZiAi, its affiliates, officers and employees from any claims arising from your violation of these Terms or misuse of the Platform.
              </p>
            </section>

            {/* Governing Law */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-gavel me-2"></i>
                1.16 Governing Law, Dispute Resolution & Arbitration
              </h2>
              <ol className="text-muted">
                <li className="mb-2">These Terms are governed by the laws of India (unless otherwise agreed). Parties will seek to resolve disputes amicably.</li>
                <li className="mb-0">If unresolved, disputes shall be referred to arbitration in [City — e.g., Mumbai], India, under the Arbitration and Conciliation Act, 1996 (or local equivalent). Arbitration language: English/Hindi as applicable.</li>
              </ol>
            </section>

            {/* Changes to Terms */}
            <section className="mb-5">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-sync me-2"></i>
                1.17 Changes to Terms
              </h2>
              <p className="text-muted mb-0">
                WiZiAi may modify these Terms. Material changes will be communicated via email or in-app notice. Continued use after notice implies acceptance of updated Terms.
              </p>
            </section>

            {/* Contact */}
            <section className="mb-0">
              <h2 className="h3 fw-bold mb-3" style={{ color: '#667eea' }}>
                <i className="fas fa-envelope me-2"></i>
                1.18 Contact & Grievance Officer
              </h2>
              <div className="card bg-light border-0">
                <div className="card-body">
                  <p className="mb-2"><strong>BRAINTONICA EDTECH LLP</strong></p>
                  <p className="mb-2">[Registered address]</p>
                  <p className="mb-2">Email: <a href="mailto:privacy@wiziai.in" className="text-decoration-none">privacy@wiziai.in</a></p>
                  <p className="mb-2">Grievance Officer: [Name]</p>
                  <p className="mb-0">Phone: [Number]</p>
                </div>
              </div>
            </section>

          </div>
          
          {/* Footer */}
          <div className="card-footer bg-light text-center py-4">
            <p className="mb-3 text-muted">
              <i className="fas fa-file-pdf text-danger me-2"></i>
              Need a PDF copy of these terms?
            </p>
            <a 
              href="/terms.pdf" 
              download="WiziAI_Terms_of_Service.pdf"
              className="btn btn-primary me-3"
              style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none'
              }}
            >
              <i className="fas fa-download me-2"></i>
              Download PDF
            </a>
            <a 
              href="/terms.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline-secondary"
            >
              <i className="fas fa-external-link-alt me-2"></i>
              Open PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
